// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'name',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'rank',
    Object: 'value',
    label: '',
    width: '150'
  }, {
    prop: 'prizeable',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'image',
    label: '',
    width: '150',
    img: true
  }, {
    prop: 'count',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'probability',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'online',
    label: '',
    Object: 'value',
    width: '150'
  }]
}
